import { useParams } from "react-router-dom";

/**
 * Returns a function that prefixes paths with the current language.
 * Usage: const lp = useLocalizedPath(); <Link to={lp("/horses")} />
 */
export const useLocalizedPath = () => {
  const { lang } = useParams<{ lang: string }>();
  const currentLang = lang || "en";

  return (path: string) => `/${currentLang}${path === "/" ? "" : path}`;
};
